import React from 'react';
import { Switch, Route } from 'react-router-dom';
import List from './accounts/List';
import Show from './accounts/Show';
import Editor from './accounts/Editor';
import ScraperDocuments from './accounts/scraperDocuments/ScraperDocuments';
import ShopEditor from './shops/Editor';
import ShopShow from './shops/Show';

const AdminAccounts = () => (
  <Switch>
    <Route component={List} exact path="/admin/accounts" />
    <Route
      exact
      path="/admin/accounts/new"
      render={(props) => <Editor key={props.location.pathname} isNew={true} />}
    />
    {/* Must stay before `/admin/accounts/:id`, otherwise `:id` matches "scraper_documents" */}
    <Route component={ScraperDocuments} exact path="/admin/accounts/scraper_documents" />
    <Route
      exact
      path="/admin/accounts/:id/shops/new"
      render={(props) => (
        <ShopEditor key={props.location.pathname} accountId={props.match.params.id} isNew={true} />
      )}
    />
    <Route
      exact
      path="/admin/accounts/:id/shops/:shopId"
      render={(props) => (
        <ShopShow accountId={props.match.params.id} shopId={props.match.params.shopId} />
      )}
    />
    <Route
      exact
      path="/admin/accounts/:id/shops/:shopId/edit"
      render={(props) => (
        <ShopEditor
          key={props.location.pathname}
          accountId={props.match.params.id}
          isNew={false}
          shopId={props.match.params.shopId}
        />
      )}
    />
    <Route
      exact
      path="/admin/accounts/:id/edit"
      render={(props) => (
        <Editor key={props.location.pathname} accountId={props.match.params.id} isNew={false} />
      )}
    />
    <Route
      exact
      path="/admin/accounts/:id"
      render={(props) => <Show accountId={props.match.params.id} />}
    />
  </Switch>
);

export default AdminAccounts;
